export const calculateSum = (numbers: number[]) => numbers.reduce((acc, num) => acc + num, 0);
